import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import '../styles/AboutUs.css';

const AboutUs = () => {
  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="about-us">
      {/* Hero Section */}
      <section className="about-hero">
        <div className="about-hero-background">
          <div className="about-hero-shapes">
            <div className="hero-shape hero-shape-1"></div>
            <div className="hero-shape hero-shape-2"></div>
            <div className="hero-shape hero-shape-3"></div>
          </div>
        </div>
        
        <div className="about-hero-content">
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="hero-text"
          >
            <Link to="/" className="back-home">
              <i className="fas fa-arrow-left"></i>
              Volver al inicio
            </Link>
            
            <h1>Sobre Nosotros</h1>
            <p className="hero-subtitle">
              Acercamos la tecnología a los procesos empresariales y creamos 
              soluciones tecnológicas a medida de cada empresa.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Mission Section */}
      <section className="mission-section">
        <div className="container">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="mission-content"
          >
            <h2>Nuestra Misión</h2>
            <p className="mission-text">
              Creemos que la tecnología debe ser accesible y útil para todas las empresas. 
              Por eso, nos dedicamos a crear soluciones que simplifican procesos complejos 
              y potencian el crecimiento empresarial a través de la automatización inteligente 
              y el desarrollo de software personalizado.
            </p>
          </motion.div>
        </div>
      </section>



      {/* Philosophy Quote */}
      <section className="philosophy-section">
        <div className="container">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="philosophy-content"
          >
            <div className="philosophy-quote">
              <i className="fas fa-quote-left"></i>
              <blockquote>
                "La tecnología no debe ser compleja. Debe ser la herramienta 
                que simplifica lo complejo y potencia lo extraordinario."
              </blockquote>
            </div>
          </motion.div>
        </div>
      </section>


    </div>
  );
};

export default AboutUs; 